import { render, staticRenderFns } from "./DefaultError.vue?vue&type=template&id=744625aa&scoped=true&"
import script from "./DefaultError.vue?vue&type=script&lang=ts&"
export * from "./DefaultError.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultError.vue?vue&type=style&index=0&id=744625aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744625aa",
  null
  
)

export default component.exports